import axios, {GenericAbortSignal} from 'axios';
import {makeAutoObservable} from 'mobx';
import {api} from '../api/endpoints';
import AppStore from '../app.store';

class PaymentMethodsStore {
    public paymentMethods: any[] = [];
    public loading = false;

    constructor() {
        makeAutoObservable(this);
    }

    public paymentMethodsInit = (signal: GenericAbortSignal) => {
        void this.paymentMethodsReq(signal);
    };

    setPaymentMethods(data: any) {
        this.paymentMethods = data;
    }

    public paymentMethodsReq = async (signal?: GenericAbortSignal) => {
        this.loading = true;

        try {
            const {getToken} = AppStore;
            const headers = {
                Authorization: 'Bearer ' + getToken()!,
            };

            const response = await axios.get(api.payment_methods, {
                headers,
                signal,
            });
            this.setPaymentMethods(response.data);
        } catch {
            // ignore — caller handles UX
        } finally {
            this.loading = false;
        }
    };

    public destroy = () => {
        this.paymentMethods = [];
    };
}

export default new PaymentMethodsStore();
